module.exports = __webpack_public_path__ + "img/2.58f475bc.png";